import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { isMobile } from "react-device-detect"
import styled from "styled-components"

import Month from "../elements/Month"
import Block from "../elements/Block"
import Photo from "../elements/Photo"
import Video from "../elements/Video"
import Tags from "../elements/Tags"

import event_1 from "../../images/events/june/event-1.mp4"

const Grid = styled.div`
  display: grid;
  grid-gap: var(--gutter-l);
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto auto;
  grid-template-areas: ". event-1 event-1 event-1" "event-2 event-2 event-2 ." ". . culture-1 culture-1" "culture-2 culture-2 . .";
  .event-1 {
    grid-area: event-1;
  }
  .event-2 {
    grid-area: event-2;
  }
  .culture-1 {
    grid-area: culture-1;
  }
  .culture-2 {
    grid-area: culture-2;
  }
  @media (min-width: 768px) {
  }
  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: auto auto auto auto auto;
    grid-template-areas: ". event-1 event-1 ." ". . event-2 event-2" ". culture-1 . ." ". culture-1 culture-2 ." ". . culture-2 .";
  }
  @media (min-width: 1200px) {
  }
`

const June = () => {
  const data = useStaticQuery(graphql`
    query {
      juneEventOneFB: file(relativePath: { eq: "events/june/event-1-fb.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 300, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      juneEventTwo: file(relativePath: { eq: "events/june/event-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 800, maxHeight: 800, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      juneCultureOne: file(relativePath: { eq: "events/june/culture-1.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 646, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      juneCultureTwo: file(relativePath: { eq: "events/june/culture-2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 646, quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Month name="june">
      <Grid>
        <Block className="event-1">
          {isMobile ? (
            <Photo img={data.juneEventOneFB} maxWidth={600} maxHeight={300} />
          ) : (
            <Video src={event_1} width={720} height={720} />
          )}
          <h4 style={{ maxWidth: 800 }}>
            We launched an app that helps Doctors submit claims directly to
            medical bureaus.
          </h4>
          <Tags
            maxWidth={400}
            words={[
              "react",
              "reactnative",
              "graphql",
              "serverless",
              "python",
              "postgresql",
            ]}
          />
        </Block>

        <Block className="event-2">
          <Photo img={data.juneEventTwo} maxWidth={800} maxHeight={800} />
          <h4 style={{ maxWidth: 800 }}>
            It’s called Submitt. It monitors claim progress and securely stores
            patient info.
          </h4>
        </Block>

        <Block className="culture-1">
          <Photo img={data.juneCultureOne} maxWidth={600} maxHeight={646} />
          <h4 style={{ maxWidth: 600 }}>Work is important.</h4>
        </Block>
        <Block className="culture-2">
          <Photo img={data.juneCultureTwo} maxWidth={600} maxHeight={646} />
          <h4 style={{ maxWidth: 600 }}>Foosball is importanter. </h4>
        </Block>
      </Grid>
    </Month>
  )
}

export default June
